import React from 'react';

import { HomeCardBack } from '../home-card-back';

export interface HomeCustomerCardBackProps
  extends Readonly<{
    onButtonPress: () => void;
    style?: React.CSSProperties;
  }> {}

export const HomeCustomerCardBack = React.memo<HomeCustomerCardBackProps>((props) => {
  const { onButtonPress, style } = props;

  return (
    <HomeCardBack
      icon={'avatar'}
      iconColor={'quaternary'}
      empasized={'63% reduction'}
      description={'in Priority 1 incidents using end-to-end automation and prediction'}
      title={'Create future-proof customer experience'}
      onButtonPress={onButtonPress}
      style={style}
    />
  );
});
